export const defaultValuesBelonged = {
  // Common fields
  companyId: 0,
  arrivedAt: '', // Assuming date string format
  halfDayAmount: 0,
  fullDayAmount: 0,
  goWorkTime: '', // Assuming time string format
  leaveWorkTime: '', // Assuming time string format
  dayType: '',
  workAmount: 0,
  additionComment: '',
  totalAmount: 0,
  ausAmount: 0,
  ausVolume: 0,
  refuelingAmount: 0,
  refuelingVolume: 0,
  operationDistance: 0,
  additionAmount: 0,
  madangRadioValue: '0',
  cost: 0,

  // Fields for belonged type
  ryubeiVolume: 0,
  cycleVolume: 0,
};

export const defaultValuesRent = {
  // Common fields
  companyId: 0,
  arrivedAt: '', // Assuming date string format

  ryubeiAmount: 0,
  cycleAmount: 0,
  freshWaterAmount: 0,
  wasteWaterAmount: 0,
  delayAmount: 0,

  goWorkTime: '', // Assuming time string format
  leaveWorkTime: '', // Assuming time string format
  dayType: '',

  ryubeiVolume: 0,
  cycleVolume: 0,
  operationAmount: 0,

  freshWaterVolume: 0,
  wasteWaterVolume: 0,
  delayVolume: 0,

  lkmStandard: 0,
  lkmAmount: 0,
  lkmDistance: 0,

  kmlStandard: 0,
  kmlAmount: 0,
  kmlDistance: 0,

  ausAmount: 0,
  ausVolume: 0,

  refuelingAmount: 0,
  refuelingVolume: 0,

  additionAmount: 0,
  additionComment: '',

  totalAmount: 0,
  autoTotalAmount: 0,
  madangRadioValue: '0',

  // 추가
  freshWaterTotalAmount: 0,
  refuelingTotalAmount: 0,
  wasteWaterTotalAmount: 0,
  delayTotalAmount: 0,

  lkmTotalAmount: 0,
  kmlTotalAmount: 0,
  ausTotalAmount: 0,
  // Fields for rent type
};
